import styled from "styled-components"
import media from "styled-media-query"

import Img from "gatsby-image"
import { Link } from "gatsby"

export const HeaderToggle = styled.div`
  display: none;
  height: 100%;
  cursor: pointer;
  padding: 0 10vw;

  ${media.lessThan("large")`
    display: flex;
  `}
`

export const HeaderNavBox = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: flex-end;
  align-items: center;

  ${media.lessThan("large")`
    flex-direction: column;
    position: fixed;
    width: 100%;
    justify-content: center;
    padding: 1.5rem;
    background-color: var(--black);
    transition: all 0.3s ease-in;
    top: 0;
    z-index: 1500;
    left: ${props => (props.open ? "-100%" : "0")};
    `}
`

export const HeaderHamburguer = styled.div`
  background-color: var(--white);
  width: 30px;
  height: 3px;
  transition: all 0.3s linear;
  align-self: center;
  position: relative;
  transform: ${props => (props.open ? "rotate(-45deg)" : "inherit")};
  display: none;

  ::before,
  ::after {
    width: 30px;
    height: 3px;
    background-color: var(--white);
    content: "";
    position: absolute;
    transition: all 0.3s linear;
  }

  ::before {
    transform: ${props =>
      props.open ? "rotate(-90deg) translate(-10px, 0px)" : "rotate(0deg)"};
    top: -10px;
  }

  ::after {
    opacity: ${props => (props.open ? "0" : "1")};
    transform: ${props => (props.open ? "rotate(90deg) " : "rotate(0deg)")};
    top: 10px;
  }

  ${media.lessThan("large")`
    display: block;
    margin-left: auto;
  `}
`

export const Header = styled.header`
  width: 100%;
  height: auto;
  display: block;
  background-color: var(--black);
`

export const HeaderWrapper = styled.div`
  width: 80vw;
  min-width: 960px;
  margin: 0 auto;
  padding: 0;
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${media.lessThan("large")`
    min-width: 100%;
    position: fixed;
    top: 0;
    z-index: 1000;
    background-color: var(--black);
  `}
`

export const HeaderLogo = styled(Img)`
  width: 250px;

  ${media.lessThan("large")`
    width:200px;
  `}
`

export const HeaderMenu = styled.nav`
  padding: 1.25rem 0 1.25rem 1.25rem;
  display: flex;
  justify-content: space-around;
  align-items: flex-end;

  ${media.lessThan("large")`
    flex-direction: column;
    align-items: center;
  `}
`

export const HeaderMenuItem = styled(Link)`
  padding: 1.25rem 1rem;
  color: var(--white);
  text-decoration: none;
  text-transform: uppercase;
  display: flex;
  cursor: pointer;
  align-items: center;
  border-bottom: 1px solid var(--black);

  &:hover {
    color: var(--orange);
    border-bottom: 1px solid var(--orange);
  }

  ${media.lessThan("large")`
    padding: 1rem;
    text-align: center;
  `}
`

export const HeaderMenuItemLogo = styled(Link)`
  text-decoration: none;
  cursor: pointer;

  ${media.lessThan("large")`
    width:200px;
  `}
`
